// Helpers de check-in por QR code para os próximos eventos.

// Gera um token opaco de 32 caracteres hex (16 bytes) para o check-in.
export function generateCheckinToken(): string {
  const bytes = new Uint8Array(16);
  if (typeof crypto !== "undefined" && typeof crypto.getRandomValues === "function") {
    crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < bytes.length; i++) {
      bytes[i] = Math.floor(Math.random() * 256);
    }
  }
  return Array.from(bytes)
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}

// Monta a URL pública de check-in de um evento.
export function buildCheckinUrl(eventId: number, token: string): string {
  const basePath = __BASE_PATH__.split("/").filter(Boolean).join("/");
  const pathPrefix = basePath ? `/${basePath}` : "";
  return `${window.location.origin}${pathPrefix}/checkin/${eventId}?t=${token}`;
}

export type CheckinWindowStatus = "before" | "open" | "closed";

// Estado da janela de check-in com base no horário atual (ms).
export function checkinWindowStatus(
  opensAt: string | null,
  closesAt: string | null,
  now: number = Date.now(),
): CheckinWindowStatus {
  if (!opensAt || !closesAt) return "closed";
  if (now < new Date(opensAt).getTime()) return "before";
  if (now > new Date(closesAt).getTime()) return "closed";
  return "open";
}